import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useStore } from "@/context/StoreContext";
import { ShoppingBag, X } from "lucide-react";
import { img } from "@/lib/img";

// Subtle one-per-session reminder for shoppers who return with items still in their bag.
export default function CartNudge() {
  const { cart, cartCount, setCartOpen } = useStore();
  const location = useLocation();
  const navigate = useNavigate();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const hidden = ["/cart", "/checkout", "/login"].some((p) => location.pathname.startsWith(p));
    if (hidden) return;
    if (!cart || cart.length === 0) return;
    if (sessionStorage.getItem("lemce_cart_nudge_shown")) return;
    const t = setTimeout(() => {
      setShow(true);
      sessionStorage.setItem("lemce_cart_nudge_shown", "1");
    }, 1600);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  if (!show || !cart || cart.length === 0) return null;

  const first = cart[0];

  return (
    <div className="fixed bottom-6 left-6 z-[55] w-[320px] max-w-[calc(100vw-3rem)] animate-in slide-in-from-bottom-4 fade-in duration-500" data-testid="cart-nudge">
      <div className="bg-lemce-ivory border border-lemce-matte shadow-2xl">
        <div className="flex items-start gap-3 p-4">
          <div className="w-14 h-16 bg-lemce-beige shrink-0 overflow-hidden">
            {first?.image && <img src={img(first.image, 160)} alt="" loading="lazy" className="w-full h-full object-cover" />}
          </div>
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-1.5 text-[10px] tracking-widest uppercase text-lemce-taupe mb-1">
              <ShoppingBag className="w-3 h-3" strokeWidth={1.5} /> Still in your bag
            </div>
            <p className="text-sm font-medium leading-snug">
              You left {cartCount} item{cartCount !== 1 ? "s" : ""} behind.
            </p>
            <p className="text-xs text-lemce-grey mt-0.5 truncate">{first?.name}{cart.length > 1 ? ` + ${cart.length - 1} more` : ""}</p>
          </div>
          <button onClick={() => setShow(false)} data-testid="cart-nudge-close" aria-label="Dismiss" className="text-lemce-grey hover:text-lemce-matte shrink-0">
            <X className="w-4 h-4" />
          </button>
        </div>
        <button
          onClick={() => { setShow(false); setCartOpen ? setCartOpen(true) : navigate("/cart"); }}
          data-testid="cart-nudge-cta"
          className="w-full bg-lemce-matte text-lemce-ivory py-3 text-[11px] tracking-widest uppercase hover:bg-lemce-charcoal transition-colors">
          Complete Your Order
        </button>
      </div>
    </div>
  );
}
